import { DEPARTMENT_NAV_PATH } from '../constants/deptNav';
import type { User } from '../types';
import { isWorkflowDepartmentUser } from './orderScopeHelpers';

export const DEPT_QUEUE_NAV_PATHS = Object.values(DEPARTMENT_NAV_PATH);

/** Department queue routes hidden from admin sidebar (fulfillment lives on order detail). */
export const ADMIN_HIDDEN_OPERATIONS_PATHS = new Set([
  '/design',
  '/production',
  '/finishing',
  '/installation',
  '/qc',
]);

export function isNavPathHiddenForAdmin(path: string, roleId: string): boolean {
  if (roleId !== 'admin') return false;
  return ADMIN_HIDDEN_OPERATIONS_PATHS.has(path);
}

/** Sidebar section key — admin gets a dedicated Reporting group for /reports. */
export function navSectionForRole(path: string, section: string | undefined, roleId: string): string {
  if (roleId === 'admin' && path === '/reports') return 'reporting';
  return section ?? 'main';
}

/** Workflow department users use Dashboard as their job queue (not separate dept pages). */
export function usesDashboardDeptHome(
  user: User | undefined,
  userPermissions: string[],
): boolean {
  if (!user) return false;
  if (userPermissions.includes('admin')) return false;
  return isWorkflowDepartmentUser(user);
}

export function isNavPathHiddenForDeptHome(
  path: string,
  user: User | undefined,
  userPermissions: string[],
): boolean {
  if (!usesDashboardDeptHome(user, userPermissions)) return false;
  if (path === '/orders' || path === '/orders/new' || path === '/orders/drafts') return true;
  if (DEPT_QUEUE_NAV_PATHS.includes(path)) return true;
  return false;
}

export function shouldRedirectDeptRouteToDashboard(
  pathname: string,
  user: User | undefined,
  userPermissions: string[],
): boolean {
  if (!usesDashboardDeptHome(user, userPermissions)) return false;
  if (pathname === '/orders' || pathname === '/orders/new' || pathname === '/orders/drafts') return true;
  return DEPT_QUEUE_NAV_PATHS.includes(pathname);
}
